import { stateSetter } from '@/utils';

export type AgrementsType = 'GDPR' | 'Terms and conditions' | 'Privacy Policy';
export type AgrementsStatus = 'draft' | 'published' | 'unpublished' | 'archived';
export type AgreementVersionBump = 0 | 1 | 2;

export interface IAgreementTypeConfig {
	// id-ul stabil din nomenclator (api/agreement-types) — SINGURUL discriminator de
	// încredere pentru get/create/update. Numele (`name`) diferă între medii (RO/EN,
	// în funcție de seed-ul de deploy), deci nu ne mai bazăm pe el la rezolvarea tipului.
	id: number;
	apiName: string;
	label: string;
	// display-only label used across the UI (menu, tabs, titles). `label`/`apiName`
	// rămân doar pentru afișare și pentru endpoint-ul public `agreements/published`
	// (care primește un `type=<name>`); rezolvarea de tip se face exclusiv pe `id`.
	displayLabel: string;
	path: string;
}

export const AGREEMENT_TYPE_CONFIG: Record<AgrementsType, IAgreementTypeConfig> = {
	GDPR: {
		id: 1,
		apiName: 'GDPR',
		label: 'GDPR',
		displayLabel: 'Cookies',
		path: '/common/clause/gdpr'
	},
	'Terms and conditions': {
		id: 2,
		apiName: 'Termeni și condiții',
		label: 'Termeni și condiții',
		displayLabel: 'Termeni și condiții',
		path: '/common/clause/tc'
	},
	'Privacy Policy': {
		id: 3,
		apiName: 'Politica de confidențialitate',
		label: 'Politica de confidențialitate',
		displayLabel: 'Confidențialitate',
		path: '/common/clause/pp'
	}
};

// Map invers id → tip aplicație, derivat din config (sursă unică pentru id-uri).
export const AGREEMENT_TYPE_BY_ID: Record<number, AgrementsType> = Object.fromEntries(
	(Object.entries(AGREEMENT_TYPE_CONFIG) as [AgrementsType, IAgreementTypeConfig][]).map(
		([type, config]) => [config.id, type]
	)
) as Record<number, AgrementsType>;

export interface IAgreementTypeItem {
	id: number;
	name: string;
	description: string | null;
}

export interface IAgreementStatusItem {
	id: number;
	name: string;
	description: string | null;
}

export interface IAgrements {
	id: number;
	version: string;
	type: AgrementsType;
	typeId: number;
	description: string;
	status: AgrementsStatus;
	statusId?: number;
	createdAt: string;
}

export interface ICreateAgrements {
	typeId: number;
	statusId: number;
	description: string;
	versionBump: AgreementVersionBump;
}

export interface AgrementsReturnType<T extends IAgrements | IAgrements[]> {
	data: T;
	setData: stateSetter<T>;
	loading: boolean;
	loadingCTA: boolean;
	getAgrements: (
		type: AgrementsType,
		pageParam: number,
		itemsParam: number
	) => Promise<void>;
	createAgrement: (obj: ICreateAgrements, onSuccess?: (createdId?: number) => void) => Promise<void>;
	getAgrement: (id: number) => Promise<void>;
	publishAgrement: (id: number, onSuccess?: () => void) => Promise<void>;
	removeAgrement: (id: number, onSuccess?: () => void) => Promise<void>;
	page: number;
	items: number;
	setPage: stateSetter<number>;
	setItems: stateSetter<number>;
	totalPages: number;
	totalItems: number;
}
